/* eslint-disable func-names */
import React, { memo } from 'react';
// import clonedeep from 'lodash.clonedeep';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
// import Highcharts from 'highcharts';
import HighchartsRounded from 'highcharts-rounded-corners';
import variablepie from 'highcharts/modules/variable-pie.js';

// import stackedBarConfig from './config';
class RenderChartDonut extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.state = {
      activeButton: {
        index: 0,
        active: true,
      },
    };
  }

  resizeImage = chart => {
    const innerSize = parseFloat(chart.series[0].options.innerSize) / 100;
    const imageSize = Math.min(chart.plotWidth, chart.plotHeight) * innerSize; // Adjust the size based on innerSize
    const imageX = chart.plotLeft + chart.plotWidth / 2 - imageSize / 2;
    const imageY = chart.plotTop + chart.plotHeight / 2 - imageSize / 2;

    // Clear any existing images
    if (chart.customImage) {
      chart.customImage.destroy();
    }

    chart.customImage = chart.renderer
      .image(
        'https://static.toiimg.com/photo/111828903.cms', // Replace with the URL of your image
        imageX,
        imageY,
        imageSize,
        imageSize,
      )
      .add();
  };

  componentDidMount() {
    HighchartsRounded(Highcharts);
    variablepie(Highcharts);

    if (this.ref) {
      const { chart } = this.ref.current;
      const series = chart.series[0];
      series.data.forEach((point, index) => {
        if (index === 0) {
          const sliced = !point.sliced;
          point.update({
            sliced,
          });
        } else {
          point.update({
            sliced: false,
          });
        }
      });
    }

    window.addEventListener('GUTTER_AD_TYPE_HANDLING', () => {
      this.resizeChart();
    });
    window.addEventListener('GUTTER_CLOSE_AD_TYPE_HANDLING', () => {
      this.resizeChart();
    });
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (
      this.props.tab !== prevProps.tab ||
      this.props.source !== prevProps.source
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState(
        {
          activeButton: {
            index: 0,
            active: true,
          },
        },
        () => {
          const { chart } = this.ref.current;
          const series = chart.series[0];
          series.data.forEach((point, index) => {
            if (index === 0) {
              point.update({
                sliced: true,
              });
            } else {
              point.update({
                sliced: false,
              });
            }
          });
        },
      );
    }
  }

  resizeChart = () => {
    const self = this;
    const { chartIndex } = this.props;
    if (chartIndex) {
      setTimeout(() => {
        if (
          document.querySelectorAll(
            `[data-highcharts-chart="${chartIndex}"]`,
          ) &&
          document.querySelectorAll(`[data-highcharts-chart="${chartIndex}"]`)
            .length > 0 &&
          self.ref.current &&
          self.ref.current.chart
        ) {
          self.ref.current.chart.setSize(
            document.querySelectorAll(
              `[data-highcharts-chart="${chartIndex}"]`,
            )[0].offsetWidth,
          );
        }
      }, 1500);
    }
  };

  highlightSlice = sliceIndex => {
    this.setState(
      {
        activeButton: {
          index: sliceIndex,
          active:
            this.state.activeButton.index === sliceIndex
              ? !this.state.activeButton.active
              : true,
        },
      },
      () => {
        if (this.ref) {
          const { chart } = this.ref.current;
          const series = chart.series[0];
          series.data.forEach((point, index) => {
            if (index === sliceIndex) {
              // const sliced = !point.sliced;
              point.update({
                sliced: true,
              });
            } else {
              point.update({
                sliced: false,
              });
            }
          });
        }
        this.resizeImage(this.ref.current.chart);
      },
    );
  };

  render() {
    const size = this.props.isWapView
      ? {
          height: '300',
          width: '300',
        }
      : {};
    const chartConfig = {
      chart: {
        type: 'pie',
        ...size,
        events: {
          load() {
            const chart = this;
            const innerSize =
              parseFloat(chart.series[0].options.innerSize) / 100;
            const imageSize =
              Math.min(chart.plotWidth, chart.plotHeight) * innerSize; // Adjust the size based on innerSize
            const imageX = chart.plotLeft + chart.plotWidth / 2 - imageSize / 2;
            const imageY = chart.plotTop + chart.plotHeight / 2 - imageSize / 2;

            // Clear any existing images
            if (chart.customImage) {
              chart.customImage.destroy();
            }

            chart.customImage = chart.renderer
              .image(
                'https://static.toiimg.com/photo/111828903.cms', // Replace with the URL of your image
                imageX,
                imageY,
                imageSize,
                imageSize,
              )
              .add();
          },
        },
      },
      title: {
        text: '',
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
      },
      accessibility: {
        point: {
          valueSuffix: '%',
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          borderWidth: 2,
          size: '100%',
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
            format: '<div>{point.name}</div>: {point.percentage:.1f} %',
            style: {
              textOverflow: 'none',
              whiteSpace: 'nowrap',
              overflow: 'visible',
            },
          },
          innerSize: '66%',
          states: {
            hover: {
              enabled: true, // Enable hover state
            },
          },
        },
      },
      series: [
        {
          enableMouseTracking: false,
          colorByPoint: true,
          data: this.props.data.map(item => ({
            name: item.name,
            y: item.y,
            val: item.val,
            color: item.ccmain,
            borderColor: '#fff',
            borderWidth: 2,
          })),
        },
      ],
    };
    return (
      <div className="donut_chart_with_legends">
        <div className="dcwl_high_chart_wrap">
          <HighchartsReact
            ref={this.ref}
            highcharts={Highcharts}
            options={chartConfig}
            updateArgs={[true]}
          />
        </div>
        <div className="dcwl_legends_wrap">
          {this.props.data &&
            Array.isArray(this.props.data) &&
            this.props.data.map((item, index) => (
              <div
                className={`button ${
                  this.state.activeButton.index === index ? 'active' : ''
                }`}
                style={
                  this.state.activeButton.index === index
                    ? {
                        backgroundColor: item.cclight,
                        borderColor: item.ccmain,
                      }
                    : {}
                }
                onClick={() => this.highlightSlice(index)}
              >
                <span
                  style={{
                    backgroundColor: item.ccmain,
                  }}
                />{' '}
                {item.name} {`(${item.y}%)`}
              </div>
            ))}
        </div>
      </div>
    );
  }
}

export default memo(RenderChartDonut);
